import React, {
  useCallback,
  useState,
  useContext,
  createContext,
  useMemo,
} from 'react';

const ModalTalhaoContext = createContext({});

export function ModalTalhaoProvider({ children }) {
  const [showModalTalhao, setShowModalTalhao] = useState(false);

  const openModalTalhao = useCallback(() => {
    setShowModalTalhao(true);
  }, []);

  const closeModalTalhao = useCallback(() => {
    setShowModalTalhao(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      showModalTalhao,
      openModalTalhao,
      closeModalTalhao,
    }),
    [showModalTalhao, openModalTalhao, closeModalTalhao],
  );

  return (
    <ModalTalhaoContext.Provider value={contextValue}>
      {children}
    </ModalTalhaoContext.Provider>
  );
}

export function useTalhaoModal() {
  const context = useContext(ModalTalhaoContext);

  if (!context)
    throw new Error('useTalhaoModal must be used within a ModalTalhaoProvider');

  return context;
}
